import { Fragment } from 'react';
import {
  Stack,
  RadioGroup,
  Radio,
  TableBody,
  TableRow,
  Box,
} from '@mui/material';
import {
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const radioId = ['disease.detail.radio'];

const 영역1 = [
  {
    id: 1,
    ko: '1. V/S check',
    info: [
      '4가지 항목 (혈압, 맥박, 호흡수, 체온) 모두 측정',
      '수혈시 측정하는 V/S는 제외',
    ],
    desc: [
      'I. 질병의 전적인 부정',
      'II. 병들었으나 도움이 필요한 상태라는 인식이 조금 있으며, 동시에 그렇지 않다고 생각함. (부정)',
      'III. 병들었음을 인정하나 그 원인이 기질적 요인이나 외적 요인 혹은 타인에게 있다고 봄.',
      'IV. 병들었으나 그 원인이 환자 자신 속에 있는 무엇인가 알 수 없는 것 때문이라고 여김.',
      'Ⅴ. 지적통찰 : 자기가 병들었음을 인정하고 증상과 적응실패가 자신의 비합리적인 정서와 심리적 장애 때문임을 알지만 그러나 이해나 지식이 행동화되지 않음.',
      'Ⅵ. 진실된 감정적 통찰 : 환자 자신과 자신의 일상에 중요한 인물들의 동기과 느낌을 잘 알고 그러한 앎이 행동으로 옮겨져서 행동에 근본적인 변화가 일어남.',
    ],
  },
];

const Disease = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  const handleChange1 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
  };

  return (
    <Fragment>
      <SectionTitle title="병식" />

      <RowContainer xs={12}>
        <RowContent title="병식" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <TableBody>
              {영역1.map(
                (
                  content: {
                    id: number;
                    ko: string;
                    info: string[];
                    desc: string[];
                  },
                  i
                ) => (
                  <TableRow>
                    <StyledTableCellWithoutLeftTwo
                      sx={{
                        borderBottom: 영역1.length - 1 === i ? 'none' : '',
                      }}
                    >
                      <RadioGroup
                        name={radioId[content.id - 1]}
                        defaultValue={Number(
                          getValues(radioId[content.id - 1])
                        )}
                      >
                        {content.desc.map((point, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '0px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={radioId[content.id - 1]}
                                  value={i}
                                  onChange={handleChange1}
                                />
                              </Box>
                            </TableRow>
                          );
                        })}
                      </RadioGroup>
                    </StyledTableCellWithoutLeftTwo>
                    <StyledTableCellWithoutLeftRightTwo
                      sx={{
                        borderBottom: 영역1.length - 1 === i ? 'none' : '',
                        paddingTop: '0px',
                      }}
                    >
                      <Box>
                        {content.desc.map((v, i) => (
                          <TableRow
                            sx={{
                              lineHeight: '42px',
                            }}
                          >
                            <Box sx={{ minWidth: '500px' }}>{v}</Box>
                          </TableRow>
                        ))}
                      </Box>
                    </StyledTableCellWithoutLeftRightTwo>
                  </TableRow>
                )
              )}
            </TableBody>
          </Stack>
        </RowContent>

        <RowContent title="추가적인 내용" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1}>
            <Form.MuiTextField
              required={false}
              disabled={disabled}
              placeholder="추가적인 내용을 적어주세요."
              fullWidth
              {...register('disease.detail.input')}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Disease;
